import 'jquery';

/**
 * @see https://amazonpaycheckoutintegrationguide.s3.amazonaws.com/amazon-pay-checkout/amazon-pay-script.html#amazon-pay-script
 * @see https://gist.github.com/lemked/7acdc1fbb03ec69576d1ef2776ae2f0e
 */
(function ($) {

  let amazonPayButtonEl = $('#AmazonPayButton');

  /**
   *
   var amazonPayButton = amazon.Pay.renderButton('#AmazonPayButton', {
     merchantId: 'xxxxx',
     ledgerCurrency: 'EUR',
     sandbox: true,
     checkoutLanguage: 'en_GB',
     productType: 'PayAndShip',
     placement: 'Cart',
     buttonColor: 'Gold'
  });

   amazonPayButton.onClick(function(){
  // define your custom actions here

  amazonPayButton.initCheckout({
      createCheckoutSessionConfig: {
        payloadJSON: 'payload',
        signature: 'xxxx',
        publicKeyId: 'xxxxxxxxxx'
      }
    });
  });
   */

  if (!amazonPayButtonEl.length) {
    return;
  }

  amazonPayButtonEl.on('click', function(event){
    let configUrl = $(this).data('config'),
      countrySelector = $('[data-country]:first'),
      country = countrySelector.find(':selected').attr('value');

    event.preventDefault();
    $(this).addClass('loading').prop('disabled', true);

    $.getJSON(
      configUrl,
      {
        country: country,
      },
      function (configData) {
        $('body').trigger('plenigo.initAmazon', {
          lib: 'https://static-eu.payments-amazon.com/checkout.js',
          data: configData,
          method: 'checkout',
        });
      });
  });

}(jQuery));

// /**
//  * @see https://amazonpaycheckoutintegrationguide.s3.amazonaws.com/amazon-pay-recurring-checkout/display-shipping-payment-info.html#2-enable-shipping-and-payment-updates
//  */
// (function ($, window) {
//
//   let config = $('[data-amazon-config]');
//
//   if (!config.length) {
//     return;
//   }
//
//   // get all change button events
//   $('.address a.edit').on('click', function (e) {
//     let configData = config.data('amazon-config');
//     $('body').trigger('plenigo.initAmazon', {
//       lib: 'https://static-eu.payments-amazon.com/checkout.js',
//       data: configData,
//       method: 'change',
//     });
//   });
//
// }(jQuery, window));
